module.exports = __webpack_public_path__ + "img/finney.bf1994f7.svg";